import { Box, BoxProps, Typography, TypographyProps } from '@mui/material';
import { colorsDark } from 'assets/theme/colorUtil';
import LoaderComponent from 'components/Loader';

interface ColourProps extends BoxProps {
	value: number | string;
	title: string;
	isLoading?: boolean;
	boxColor?: keyof typeof colorsDark.boxColor;
	labelProps?: TypographyProps;
	valueProps?: TypographyProps;
	border?: string;
	isActive?: boolean;
}

const DataInfoColorWidget = ({ value, title, boxColor, labelProps, valueProps, isLoading, border, isActive, ...props }: ColourProps) => {
	const numericValue = typeof value === 'number' ? value : Number(value);
	const activeBorderColor = boxColor ? colorsDark.boxColor[boxColor].color : 'transparent';
	return (
		<Box
			{...props}
			sx={{
				display: 'flex',
				flexGrow: 1,
				borderRadius: '4px',
				padding: '12px 8px',
				backgroundColor: !!boxColor ? colorsDark.boxColor[boxColor].bgColor : 'primary.main',
				position: 'relative',
				overflow: 'hidden',
				border: title == 'Not Scheduled'? '1px solid rgba(169, 173, 203, 1)' : 'none',
				borderBottom: isActive ? `7px solid ${activeBorderColor}` : undefined,
				'&:hover': numericValue > 0
				? {
					boxShadow: '0 6px 14px rgba(0,0,0,0.12)',
					transform: 'translateY(-1px)',
          			cursor: 'pointer',
				  } : { cursor: 'default', },
				...props.sx
			}}
		>
			<Box
				sx={{
					height: '100%',
					display: 'flex',
          flexGrow: 1,
					flexDirection: 'column',
					justifyContent: 'center',
					gap: 0.5,
					zIndex: 1
				}}
			>
				<Typography variant="bodyText" lineHeight="normal" {...labelProps}>
					{title}
				</Typography>
				{!!isLoading ? (
					<LoaderComponent size={20}/>
				) : (
					<Typography variant="bodyValue" lineHeight="24px" {...valueProps}>
						{value}
					</Typography>
				)}
			</Box>
			<Box
				sx={{
					position: 'absolute',
					right: 0,
					top: 0,
					bottom: 0,
					width: '8px',
					backgroundColor: !!boxColor ? colorsDark.boxColor[boxColor].color : 'primary.main',
					opacity: 0.5
				}}
				className='colorIntimation'
			/>
		</Box>
	);
};

export default DataInfoColorWidget;
